import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { noticesApiRef } from '../types';

export const NOTICES_QUERY_KEY = 'neo4j-notices';

/** A notice published during an incident reaches an open portal tab within this interval. */
export const NOTICES_REFETCH_INTERVAL_MS = 60_000;

export const noticesQueryKey = [NOTICES_QUERY_KEY] as const;

export function useNotices(options?: { poll?: boolean }) {
  const api = useApi(noticesApiRef);
  return useQuery({
    queryKey: noticesQueryKey,
    queryFn: () => api.listNotices(),
    refetchInterval: options?.poll ? NOTICES_REFETCH_INTERVAL_MS : false,
  });
}
